var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { fill: '#2780FF', d: 'M4 2h16c1.105 0 2 .893 2 1.994V4c0 .529-.21 1.2-.586 1.575l-6.12 6.101a1 1 0 00-.294.708v3.653a1 1 0 01-.298.712l-4.12 4.064C9.918 21.282 9 20.813 9 20v-7.587a1 1 0 00-.292-.707L2.586 5.575C2.21 5.2 2 4.523 2 3.994 2 2.893 2.895 2 4 2z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function filterFilled(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};